<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="destekTalebi">Destek talep et
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import destekService from '../../../WSProvider/TeknikDestek';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userData5B = "";
    export default {
        name: "TeknikDestekDetay",
        methods: {
            destekTalebi() {
                destekService.destekTalebi("Giriş yapamıyorum", "resim base64 ");
            }
        }
    }
</script>

<style scoped>

</style>